<template>
  <div class="flex-col page">
    <div class="flex-row section_1">
      <div class="flex-col items-center group">
        <span @click="text_8OnClick">行言君商城</span>
        <div @click="view_6OnClick" class="section_2"></div>
      </div>
      <span @click="textOnClick" class="text_1">便签</span>
      <span @click="text_1OnClick" class="text_2">办公文具</span>
      <span @click="text_2OnClick" class="text_3">文件收纳</span>
      <span @click="text_3OnClick" class="text_4">学生文具</span>
      <span @click="text_4OnClick" class="text_5">计算器</span>
      <span @click="text_5OnClick" class="text_6">画具画材</span>
      <span @click="text_6OnClick" class="text_7">文方四宝</span>
      <div class="flex-row section_3">
        <div class="flex-row group_1">
          <img src="../assets/16488068565369237271.png" class="image" />
          <span class="text_8">输入商品名称</span>
        </div>
        <div class="flex-col items-center text-wrapper">
          <span>搜索</span>
        </div>
      </div>
      <span @click="text_7OnClick" class="text_10">开通会员</span>
    </div>
    <div class="flex-col group_2">
      <div class="justify-between section_4">
        <div class="flex-row group_3">
          <img src="../images/8586e07090a12ea375be446d1c22d8ef.png" class="image_1" />
          <div class="flex-col group_4">
            <span class="text_11">游瑾怡</span>
            <span class="text_12">会员卡号：1325131555533535</span>
          </div>
        </div>
        <div class="flex-col group_5">
          <div class="flex-col items-center text-wrapper_1">
            <span>黄金会员</span>
          </div>
          <span class="text_14">会员卡到期 2021-2-3</span>
        </div>
      </div>
      <div class="flex-col group_6">
        <div class="flex-col section_5">
          <span class="text_15">PURCHASE A MIMBERSHIP</span>
          <div class="flex-col group_7">
            <div class="flex-row">
              <div class="flex-col section_6">
                <div class="justify-center">
                  <span class="text_16">99元</span>
                  <div class="right-text-wrapper flex-col items-center view">
                    <span>周会员</span>
                  </div>
                </div>
                <span class="text_18">7天服务时间</span>
                <div class="divider view_1"></div>
                <div class="flex-row group_10">
                  <img src="../assets/41c5873fe5a4e83d41d4b31eb8ee54be.png" class="image_2" />
                  <span>VIP权益</span>
                </div>
                <div class="group_11 flex-row">
                  <div class="left-section"></div>
                  <span class="text_20">全天解决咨询问题</span>
                </div>
                <div class="group_11 flex-row">
                  <div class="left-section"></div>
                  <span class="text_20">中级老师</span>
                </div>
                <div class="flex-row divider_1">
                  <div class="left-section"></div>
                  <span class="text_23">学业规划师</span>
                </div>
                <img src="../assets/16488068568702449706.png" class="image_3 image_4" />
                <div class="justify-evenly divider_2">
                  <span>孝能管理</span>
                  <span>动能管理</span>
                  <span>学能管理</span>
                </div>
              </div>
              <div class="flex-col section_7">
                <img src="../assets/16488068568700018862.png" class="image_3" />
                <div class="justify-evenly">
                  <span>孝能管理</span>
                  <span>动能管理</span>
                  <span>学能管理</span>
                </div>
              </div>
              <div class="flex-col section_8">
                <div class="flex-col">
                  <div class="flex-col group_13">
                    <div class="justify-center">
                      <span class="text_30">699元</span>
                      <div class="right-text-wrapper flex-col items-center view_7">
                        <span>白金会员</span>
                      </div>
                    </div>
                    <span class="text_32">90天服务时间</span>
                  </div>
                  <div class="flex-col">
                    <div class="divider view_8"></div>
                    <span class="text_33">VIP权益</span>
                    <span class="text_34">高级学业规划师</span>
                    <span class="text_35">高级老师</span>
                    <span class="text_36">全天解决咨询问题</span>
                  </div>
                </div>
                <div class="flex-col group_16">
                  <div class="justify-center group_17">
                    <img src="../assets/16488068568709753073.png" class="image_6" />
                    <img src="../images/694161d4fbabf6c0a310d388581690b7.png" class="image_7" />
                  </div>
                  <div class="justify-center">
                    <span>孝能管理</span>
                    <span class="text_38">学能管理</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="justify-around group_18">
              <div class="left-text-wrapper flex-col items-center">
                <span>立即开通</span>
              </div>
              <div class="left-text-wrapper flex-col items-center">
                <span>立即开通</span>
              </div>
              <div class="left-text-wrapper flex-col items-center">
                <span>立即开通</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-col section_9">
          <img src="../assets/c02ba79eab197a62bb9c3bf48ebe6082.png" @click="image_3OnClick" class="image_8" />
          <img src="../assets/16488068565360356644.png" class="image_9" />
          <span class="text_42">开通成功</span>
          <div class="justify-center group_19">
            <span class="text_43">金额</span>
            <span>200元</span>
          </div>
          <div class="justify-evenly group_20">
            <span>订单编号</span>
            <span>4589245634566</span>
          </div>
          <div class="justify-evenly group_21">
            <span class="text_47">收件人</span>
            <span class="text_48">鲁瑶婉</span>
            <span class="text_49">13112342304</span>
          </div>
          <div @click="view_19OnClick" class="flex-col items-center text-wrapper_2">
            <span>返回首页</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    methods: {
      text_8OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      view_6OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      textOnClick() {
        this.$router.push({ name: 'bianqian' });
      },
      text_1OnClick() {
        this.$router.push({ name: 'bangongwenju' });
      },
      text_2OnClick() {
        this.$router.push({ name: 'wenjushouna' });
      },
      text_3OnClick() {
        this.$router.push({ name: 'xueshengwenju' });
      },
      text_4OnClick() {
        this.$router.push({ name: 'jisuanqi' });
      },
      text_5OnClick() {
        this.$router.push({ name: 'huajuhuacai' });
      },
      text_6OnClick() {
        this.$router.push({ name: 'wenfangsibao' });
      },
      text_7OnClick() {
        this.$router.push({ name: 'Page_huiyuankaitongyemianbeifen_2' });
      },
      image_3OnClick() {
        this.$router.push({ name: 'Page_huiyuankaitongyemianbeifen_2' });
      },
      view_19OnClick() {
        this.$router.push({ name: 'wenju' });
      },
    },
  };
</script>

<style scoped lang="css">
  .left-text-wrapper {
    padding: 0.094rem 0 0.094rem;
    background-image: linear-gradient(
      90.5deg,
      rgb(255, 237, 201) 0%,
      rgb(255, 237, 201) -0.11%,
      rgb(249, 209, 138) 99.96%,
      rgb(249, 209, 138) 100%
    );
    border-radius: 0.22rem;
    width: 1.88rem;
    height: 0.41rem;
  }
  .divider {
    background-color: rgba(4, 2, 20, 0.06);
    height: 0.063rem;
  }
  .group_11 {
    color: rgba(99, 2, 2, 0.8);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    padding: 0 0.28rem 0.13rem;
  }
  .image_3 {
    width: 2.28rem;
    height: 0.47rem;
  }
  .right-text-wrapper {
    color: rgb(255, 255, 255);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    padding: 0.063rem 0;
    background-image: linear-gradient(
      113.3deg,
      rgb(255, 151, 84) 0%,
      rgb(255, 151, 84) -33.23%,
      rgb(255, 72, 72) 120.66%,
      rgb(255, 72, 72) 100%
    );
    border-radius: 0px 0.094rem 0px 0.094rem;
    width: 0.84rem;
    height: 0.34rem;
  }
  .left-section {
    background-color: rgb(77, 40, 40);
    border-radius: 50%;
    width: 0.094rem;
    height: 0.094rem;
  }
  .text_20 {
    margin-left: 0.094rem;
  }
  .page {
    background-color: rgb(91, 91, 91);
    width: 100%;
    overflow-y: auto;
    height: 100%;
  }
  .section_1 {
    padding: 0.16rem 0 0.16rem;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0.011rem 0px 0px rgb(245, 86, 86);
    position: relative;
  }
  .group_2 {
    padding: 0.69rem 3.75rem 0 3.75rem;
  }
  .group {
    margin-left: 2.94rem;
    padding-bottom: 0.063rem;
    color: rgb(255, 73, 73);
    font-size: 0.22rem;
    font-weight: 500;
    line-height: 0.31rem;
    white-space: nowrap;
    position: relative;
  }
  .text_1 {
    margin-left: 0.47rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_2 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_3 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_4 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_5 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_6 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_7 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .section_3 {
    margin-left: 1.13rem;
    padding-left: 0.13rem;
    background-color: rgb(255, 255, 255);
    border-radius: 0.031rem;
    height: 0.41rem;
    border: solid 0.063rem rgb(245, 86, 86);
  }
  .text_10 {
    margin-left: 0.28rem;
    color: rgb(245, 86, 86);
    font-size: 0.22rem;
    font-weight: 500;
    line-height: 0.31rem;
    white-space: nowrap;
  }
  .section_4 {
    padding-left: 0.16rem;
    padding-bottom: 0.34rem;
    background-image: url('../assets/497d4f7d0aa8d1fcf17cb0610f54de8c.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .group_6 {
    padding: 0.56rem 0 0.75rem;
    position: relative;
  }
  .section_2 {
    background-color: rgb(255, 73, 73);
    width: 0.28rem;
    height: 0.063rem;
    position: absolute;
    left: 0.094rem;
    bottom: 0;
  }
  .group_1 {
    color: rgb(125, 122, 133);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text-wrapper {
    margin-left: 0.84rem;
    color: rgb(255, 255, 255);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
    background-color: rgb(245, 86, 86);
    border-radius: 0.031rem;
    width: 0.78rem;
    height: 0.41rem;
    border: solid 0.063rem rgb(245, 86, 86);
  }
  .group_3 {
    margin-top: 0.38rem;
  }
  .group_5 {
    width: 2.72rem;
  }
  .section_5 {
    padding: 0.53rem 1.41rem 0.31rem 1.84rem;
    background-color: rgb(255, 255, 255);
    border-radius: 0.19rem;
    border: solid 0.11rem rgb(255, 239, 210);
  }
  .section_9 {
    padding: 0.5rem 0.88rem 0.47rem 0.88rem;
    background-color: rgb(245, 245, 245);
    box-shadow: 0px 0.021rem 0.042rem 0px rgba(0, 0, 0, 0.19);
    border-radius: 0.063rem;
    width: 4.06rem;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .image {
    width: 0.38rem;
    height: 0.28rem;
  }
  .text_8 {
    margin-left: 0.13rem;
  }
  .image_1 {
    width: 0.91rem;
    height: 0.91rem;
  }
  .group_4 {
    margin-left: 0.25rem;
    margin-top: 0.094rem;
  }
  .text-wrapper_1 {
    padding: 0.094rem 0 0.094rem;
    align-self: flex-end;
    color: rgb(255, 255, 255);
    font-size: 0.22rem;
    line-height: 0.31rem;
    white-space: nowrap;
    background-image: linear-gradient(
      111.4deg,
      rgb(255, 72, 72) 0%,
      rgb(255, 72, 72) -33.23%,
      rgb(255, 151, 84) 120.66%,
      rgb(255, 151, 84) 100%
    );
    border-radius: 0px 0.19rem 0px 0.16rem;
    width: 1.34rem;
  }
  .text_14 {
    margin-top: 0.47rem;
    align-self: center;
    color: rgb(8, 4, 23);
    font-size: 0.25rem;
    line-height: 0.34rem;
    white-space: nowrap;
  }
  .text_15 {
    align-self: center;
    color: rgba(51, 51, 51, 0.11);
    font-size: 0.38rem;
    font-weight: 600;
    line-height: 0.5rem;
    white-space: nowrap;
  }
  .group_7 {
    margin-top: 0.59rem;
  }
  .image_8 {
    width: 0.16rem;
    height: 0.16rem;
    position: absolute;
    right: 0.19rem;
    top: 0.19rem;
  }
  .image_9 {
    align-self: center;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    position: relative;
  }
  .text_42 {
    margin-top: 0.16rem;
    align-self: center;
    color: rgb(8, 4, 23);
    font-size: 0.19rem;
    line-height: 0.25rem;
    white-space: nowrap;
    position: relative;
  }
  .group_19 {
    margin-top: 0.41rem;
    padding: 0 0.34rem;
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    position: relative;
  }
  .group_20 {
    padding: 0.13rem 0 0.13rem;
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    position: relative;
  }
  .group_21 {
    padding-left: 0.16rem;
    position: relative;
  }
  .text-wrapper_2 {
    margin: 1.34rem 0.094rem 0 0.094rem;
    padding: 0.094rem 0;
    color: rgb(255, 255, 255);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    background-color: rgb(86, 96, 245);
    border-radius: 0.031rem;
    width: 2.09rem;
    position: relative;
  }
  .text_11 {
    color: rgb(59, 49, 44);
    font-size: 0.31rem;
    font-weight: 500;
    line-height: 0.44rem;
    white-space: nowrap;
  }
  .text_12 {
    margin-top: 0.063rem;
    color: rgb(59, 49, 44);
    font-size: 0.22rem;
    line-height: 0.28rem;
    white-space: nowrap;
  }
  .group_18 {
    margin-top: 0.094rem;
    padding: 0 0.41rem;
    color: rgb(87, 67, 28);
    font-size: 0.16rem;
    font-weight: 500;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_43 {
    position: absolute;
    left: 0.34rem;
    top: 50%;
    transform: translateY(-50%);
  }
  .text_47 {
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_48 {
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_49 {
    color: rgb(8, 4, 23);
    font-size: 0.13rem;
    line-height: 0.19rem;
    white-space: nowrap;
  }
  .section_6 {
    padding-left: 0.16rem;
    padding-bottom: 0.19rem;
    flex: 1 1 2.72rem;
    border-radius: 0.094rem;
    background-image: url('../assets/02eaea9df92b3a9841d92b73d1cfc85b.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 4.34rem;
  }
  .section_7 {
    margin-left: 0.22rem;
    padding: 3.41rem 0.16rem 0.19rem 0.16rem;
    flex: 1 1 2.72rem;
    color: rgba(72, 54, 21, 0.8);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    border-radius: 0.094rem;
    background-image: url('../assets/641e589b427abee770c0a867b30c8bc1.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 4.34rem;
  }
  .section_8 {
    margin-left: 0.22rem;
    margin-right: 0.47rem;
    padding-left: 0.16rem;
    padding-bottom: 0.19rem;
    flex: 1 1 2.72rem;
    border-radius: 0.094rem;
    background-image: url('../assets/9c4e227afcd743702bcdec319535c894.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 4.34rem;
  }
  .text_18 {
    color: rgba(99, 2, 2, 0.6);
    font-size: 0.13rem;
    line-height: 0.19rem;
    white-space: nowrap;
  }
  .view_1 {
    margin-right: 0.13rem;
    margin-top: 0.19rem;
  }
  .group_10 {
    padding: 0.13rem 0 0.19rem;
    color: rgb(99, 2, 2);
    font-size: 0.16rem;
    font-weight: 500;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .divider_1 {
    padding: 0 0.28rem;
    color: rgba(99, 2, 2, 0.8);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .image_4 {
    margin-top: 1.09rem;
    align-self: center;
  }
  .divider_2 {
    color: rgba(99, 2, 2, 0.8);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .group_16 {
    margin-top: 1.09rem;
    color: rgba(16, 20, 59, 0.8);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_16 {
    margin-top: 0.16rem;
    color: rgb(99, 2, 2);
    font-size: 0.25rem;
    font-weight: 500;
    line-height: 0.34rem;
    white-space: nowrap;
  }
  .view {
    margin-left: 1.16rem;
    margin-bottom: 0.19rem;
  }
  .image_2 {
    width: 0.25rem;
    height: 0.25rem;
  }
  .text_23 {
    margin-left: 0.094rem;
  }
  .group_13 {
    padding-bottom: 0.19rem;
  }
  .group_17 {
    padding-bottom: 0.063rem;
  }
  .text_32 {
    color: rgba(53, 57, 91, 0.6);
    font-size: 0.13rem;
    line-height: 0.19rem;
    white-space: nowrap;
  }
  .view_8 {
    margin-right: 0.13rem;
  }
  .text_33 {
    margin-left: 0.28rem;
    margin-top: 0.13rem;
    color: rgb(67, 71, 109);
    font-size: 0.16rem;
    font-weight: 500;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_34 {
    margin-top: 0.19rem;
    align-self: center;
    color: rgba(66, 70, 112, 0.8);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_35 {
    margin-left: 0.47rem;
    margin-top: 0.13rem;
    color: rgba(66, 70, 112, 0.8);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_36 {
    margin-top: 0.13rem;
    align-self: center;
    color: rgba(66, 70, 112, 0.8);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .image_6 {
    width: 1.38rem;
    height: 0.47rem;
  }
  .image_7 {
    margin-left: 0.41rem;
    width: 0.47rem;
    height: 0.47rem;
  }
  .text_38 {
    margin-left: 1.22rem;
  }
  .text_30 {
    margin-top: 0.16rem;
    color: rgb(53, 57, 91);
    font-size: 0.25rem;
    font-weight: 500;
    line-height: 0.34rem;
    white-space: nowrap;
  }
  .view_7 {
    margin-left: 1rem;
    margin-bottom: 0.19rem;
  }
</style>